import { Box, styled } from '@mui/material';

export const AnimatedContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'mapExpanded',
})<{ mapExpanded: boolean }>(({ mapExpanded }) => ({
    width: mapExpanded ? '100%' : '50%',
    transition: 'width 0.5s ease-in-out',
    display: 'flex',
    flexDirection: 'column',
}));

export const DataColumn = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'visible' && prop !== 'showCharts',
})<{ visible: boolean; showCharts: boolean }>(({ visible, showCharts }) => ({
    width: visible ? (showCharts ? '100%' : '50%') : '0',
    opacity: visible ? 1 : 0,
    visibility: visible ? 'visible' : 'hidden',
    display: 'flex',
    flexDirection: 'column',
}));
